import { apiFetch } from "../services/api.js";

// Função para exportar dados em CSV (Excel)
export async function exportarEmExcel() {
  try {
    const clientesRes = await apiFetch("clientes");
    // fetch only active, non-archived campaigns
    const campanhasRes = await apiFetch("campanhas");
    const campanhasAtivas = (campanhasRes?.campanhas || []).filter(
      (c) => c.ativo !== false && c.arquivado !== true,
    );

    const clientes = clientesRes?.clientes || [];
    // fetch cupons only for active campaigns
    let cupons = [];
    for (const c of campanhasAtivas) {
      try {
        const resp = await apiFetch(`cupons/campanha/${c.id}`);
        cupons.push(...(resp?.cupons || []));
      } catch (e) {
        console.warn("Erro ao buscar cupons da campanha", c.id, e.message);
      }
    }

    // Preparar dados: cada cupom em coluna separada
    // Encontrar o máximo de cupons de um cliente para saber quantas colunas criar
    const maxCupons = Math.max(
      0,
      ...clientes.map(
        (c) => cupons.filter((cu) => cu.cliente_id === c.id).length,
      ),
    );

    // Criar headers dinâmicos para "Cupom 1", "Cupom 2", etc.
    const headers = ["Nome", "CPF/CNPJ", "Total de Cupons"];
    for (let i = 1; i <= maxCupons; i++) {
      headers.push(`Cupom ${i}`);
    }

    // Preparar linhas com cupons nas colunas
    const rows = clientes.map((cliente) => {
      const cuponsCliente = cupons.filter((c) => c.cliente_id === cliente.id);
      const linha = [
        cliente.nome,
        cliente.documento,
        String(cuponsCliente.length),
      ];
      // Adicionar cada cupom em sua coluna
      for (let i = 0; i < maxCupons; i++) {
        linha.push(cuponsCliente[i]?.codigo || "");
      }
      return linha;
    });

    // Função para escapar valores CSV
    const escapeCSV = (cell) => {
      const cellStr = String(cell || "");
      if (
        cellStr.includes(";") ||
        cellStr.includes("\n") ||
        cellStr.includes('"')
      ) {
        return `"${cellStr.replace(/"/g, '""')}"`;
      }
      return cellStr;
    };

    const csv = [
      "\uFEFF" + headers.map(escapeCSV).join(";"),
      ...rows.map((row) => row.map(escapeCSV).join(";")),
    ].join("\n");

    // Baixar arquivo
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `sorteios_${new Date().toISOString().split("T")[0]}.csv`,
    );
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Erro ao exportar:", err);
    throw new Error(`Erro ao exportar dados: ${err.message}`);
  }
}
